export const SET_BLOCKS_DATA = '@blocks/SET_BLOCKS_DATA' as const;
export const SET_BLOCK_INFO = '@blocks/SET_BLOCK_INFO' as const;
export const SET_BLOCK_TRANSACTIONS = '@blocks/SET_BLOCK_TRANSACTIONS' as const;
